export default "__VITE_ASSET__C9C9KgkZ__"